// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M3.375 0a1.066 1.066 0 011.052.913l2.252 21.291h16.7c.418 0 .76.34.76.758a.76.76 0 01-.76.758H5.994a.758.758 0 01-.755-.68L2.962 1.515H.76A.758.758 0 11.76 0h2.615zm23.562 5.803c.329 0 .634.145.836.4.199.248.271.567.2.874l-2.013 10.85a1.059 1.059 0 01-1.043.844H8.64a.759.759 0 110-1.515h15.9l1.843-9.939H7.43a.76.76 0 01-.76-.757c0-.419.34-.757.76-.757h19.508zm-4.226 7.635c.42 0 .76.339.76.757a.76.76 0 01-.76.758H8.237a.76.76 0 01-.76-.758c0-.418.34-.757.76-.757H22.71zm.709-3.817c.419 0 .76.338.76.757a.76.76 0 01-.76.757H7.833a.76.76 0 01-.76-.757c0-.419.34-.757.76-.757H23.42zM6.95 26.403A1.6 1.6 0 015.35 28a1.6 1.6 0 01-1.603-1.597 1.6 1.6 0 011.603-1.597 1.6 1.6 0 011.601 1.597m15.94 0A1.6 1.6 0 0121.29 28a1.6 1.6 0 01-1.602-1.597 1.6 1.6 0 011.602-1.597 1.6 1.6 0 011.602 1.597"
            />
        </svg>
    );
};

export default React.memo(Cart);
